<h5 class="p-16 m-0 bottomBorderStyle">{{ title }}</h5>
<div class="pb-8 pl-16">
  <div class="pt-8 m-0 pb-10 section-title">
    SELECTED FOLDER(S)@if (count) {
    <span style="margin-left: 16px"></span>
  }
  @if (count) {
    <span class="count-icon font-s">{{ count }}</span>
  }
</div>
<p class="m-0 pb-10 secondary-text font-medium">
  Tags can only be applied to package folders
</p>
</div>
<mat-divider></mat-divider>
<div class="margin-container">
  <app-package-folder-tags-general [expandTags]="true"
    [initialValue]="commonSelectedTags"
    (cancelOperation)="handleCancelOperation($event)" (tagsUpdated)="onTagsUpdated($event)">
  </app-package-folder-tags-general>
</div>
